import { render, staticRenderFns } from "./CalendarMenu.vue?vue&type=template&id=3a9ddb9d"
import script from "./CalendarMenu.vue?vue&type=script&lang=js"
export * from "./CalendarMenu.vue?vue&type=script&lang=js"
import style0 from "./CalendarMenu.vue?vue&type=style&index=0&id=3a9ddb9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports